/**
 * Iniciales de una persona o empresa: la primera letra de cada palabra,
 * hasta dos. "Daniel Paez" -> "DP" (no "DA").
 */
export const getInitials = (name, fallback = "?") => {
  const words = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length === 0) return fallback;
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

  return (words[0][0] + words[1][0]).toUpperCase();
};

export default getInitials;
